export default __webpack_public_path__ + "static/media/precios_LEED_feb_sumeB.dcf77529.png";